import { useState } from 'react';

import type { RateOverrides } from 'pages/MixApplyPage/types';

const useRecipeState = () => {
    const [rateOverrides, setRateOverrides] = useState<RateOverrides>({});

    const handleRateChange = ({ productId, rate }: { productId: string; rate: number }) => {
        setRateOverrides(current => ({ ...current, [productId]: rate }));
    };

    return { handleRateChange, rateOverrides };
};

export default useRecipeState;
